import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.ts'
import type { Passage } from '../pegangan/pegangan.ts'

/** Mirrors apps/api/src/services/cerita.ts. */
export type CeritaKind = 'umum' | 'ayat' | 'fikih' | 'darurat'
export type FallbackReason = 'darurat' | 'fikih' | 'ai_off' | 'kuota' | 'ai_error' | 'ragu'
export type CeritaReply = {
  empati: string
  /** null = an AI answer that passed the grounding gate */
  reason: FallbackReason | null
  ayat: Passage | null
  makna: string | null
  hadis: { id: string; text: string; ar: string | null; attribution: string; grade: string; url: string; source: string; makna: string | null } | null
  langkah: string | null
  pegangan: { slug: string; judul: string } | null
}
export type CeritaMessage = { id: string; message: string; createdAt: string; kind: CeritaKind; source: 'llm' | 'fallback'; reported: boolean; reply: CeritaReply }
export type Quota = { free: number; used: number; left: number; ai: boolean }
export type CeritaState = { ok: true; messages: CeritaMessage[]; quota: Quota }

export const CERITA_KEY = ['cerita'] as const
export const useCerita = () => useQuery({ queryKey: CERITA_KEY, queryFn: () => api<CeritaState>('GET', '/api/cerita') })

export const sendCerita = (message: string) => api<{ ok: true; message: CeritaMessage; quota: Quota }>('POST', '/api/cerita', { message })
export const reportCerita = (id: string, reason: string) => api<{ ok: true }>('POST', `/api/cerita/${id}/lapor`, { reason })
export const clearCerita = () => api<{ ok: true; deleted: number }>('POST', '/api/cerita/hapus')

/** Plain text of a reply for "Salin". */
export function replyText(m: CeritaMessage) {
  const r = m.reply
  const ayat = r.ayat?.verses ? `${r.ayat.verses.map((v) => v.terjemah).join(' ')}\n(${r.ayat.ref})` : r.ayat?.ref
  const hadis = r.hadis ? `${r.hadis.text}\n(${r.hadis.attribution}; ${r.hadis.grade})` : null
  return [r.empati, ayat, r.makna, hadis, r.langkah && `Langkah kecil: ${r.langkah}`].filter(Boolean).join('\n\n')
}
